import type { TrackService } from '@/domains/shared/services/track-service';

export function trackAiccGuestToLogin(trackService: TrackService, pageUrl: string) {
    trackService.trackAir({
        event_type: 'ss_telecom',
        source_type: 'telecom_aicc_home_guestToLogin',
        other_param: 'aicc',
        event_detail_str: JSON.stringify({
            agent: 'aicc',
            pageUrl,
            params: {},
        }),
    });
}
